import { JOBS_SCHEDULE_BASEURL } from "../constant/baseurl";
import { GetHeader, LOCALSTORAGE_KEY } from "../constant/constant";
import { utility } from "../utility/utilityProvider";

// JOB SCHEDULE API's

const JOBS_SCHEDULE_URL = {
    BASEURL: JOBS_SCHEDULE_BASEURL + "/data/"
}

//default args
var defaultArgs = {
    // MULTIPLE QUERRY EX: [ ['SID', '>', '0'], ['SID', '>', '0'], ['SID', '>', '0']  ]
    // SINGLE QUERRY EX: ['SID', '>', '0']
    query: [],
    // SORT ASC EX: { SID : 1 }
    // SORT DESC EX: { SID : -1 }
    // MULTIPLE SORTS EX: { SID : 1, DATE : -1 }
    sort: { SID: 1 },
    // 1 MEANS FIRST PAGE, 2 MEANS 2 PAGE
    page: null,
    // NO. OF ITEMS PER PAGE
    perPage: null,
    //ARCHIVE KEY
    archive: false
}

export async function getEntitiesWithSearch(entityname, args = defaultArgs, columns, searchText, filters) {

    utility.checkSessionExpire();

    try {
        var finalData = {
            query: args.query || defaultArgs.query,
            sort: args.sort || defaultArgs.sort,
            page: args.page || defaultArgs.page,
            perPage: args.perPage || defaultArgs.perPage,
            archive: args.archive || defaultArgs.archive,
            dataColumns: columns || [],
            searchText: searchText || '',
            filters: filters
        };

        var Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
        var FINALURL = JOBS_SCHEDULE_URL.BASEURL + 'getEntitiesWithSearch/' + entityname;
        console.log(finalData);
        const response = await fetch(FINALURL, Finalinit);
        const data = await response.json();

        if (data.success) {
            return data;
        }

        utility.checkTokenExpire(data);
        utility.checkIsLicenseExpire(data);

    }
    catch (error) {
        console.log("error", error.message);
    }
}

export async function saveData(entityname, saveData) {

    saveData = utility.prepareSaveData(entityname, saveData)

    try {
        const user = utility.getValue(LOCALSTORAGE_KEY.userData);
        var FINALURL = JOBS_SCHEDULE_URL.BASEURL + "saveData/" + entityname;

        //prepare data
        const finalData = {
            data: saveData,
            user: { _id: user?._id ?? "", name: user?.name ?? "" }
        }
        var Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };

        const response = await fetch(FINALURL, Finalinit);
        const responseData = await response.json();

        console.log('Saved data response');
        console.log(responseData);
        if (!responseData.success) {
            utility.checkTokenExpire(responseData);
        }
        return responseData;

    }
    catch (error) {
        console.log("error", error.message);
    }

}

export async function scheduleJobs() {
    try {

        //TESTING
        let BASEURL = `${JOBS_SCHEDULE_BASEURL}/jobs/`
        // let BASEURL = "http://localhost:4000/jobs/"

        var FINALURL = BASEURL + "scheduleJobs";
        var Finalinit = { ...GetHeader('GET') };
        const response = await fetch(FINALURL, Finalinit);
        const data = await response.json();
        if (data.success) {
            return data;
        }
        // utility.checkTokenExpire(data);
    }
    catch (error) {
        console.log("error", error);
    }

}

export async function stopJob(jobId) {
    try {

        //TESTING
        let BASEURL = `${JOBS_SCHEDULE_BASEURL}/jobs/`
        // let BASEURL = "http://localhost:4000/jobs/"

        var FINALURL = BASEURL + "stopJob/" + `${jobId}`;
        var Finalinit = { ...GetHeader('GET') };
        const response = await fetch(FINALURL, Finalinit);
        const data = await response.json();
        if (data.success) {
            return data;
        }
        // utility.checkTokenExpire(data);
    }
    catch (error) {
        console.log("error", error);
    }

}


export async function runTestScheduleJob(payload) {
    try {

        //TESTING
        let BASEURL = `${JOBS_SCHEDULE_BASEURL}/jobs/`
        // let BASEURL = "http://localhost:4000/jobs/"

        var FINALURL = BASEURL + "createMaintainJob";
        var Finalinit = { ...GetHeader('POST'), "body": JSON.stringify(payload) };
        const response = await fetch(FINALURL, Finalinit);
        const data = await response.json();
        if (data.success) {
            return data;
        }
        // utility.checkTokenExpire(data);
    }
    catch (error) {
        console.log("error", error);
    }

}